import { useCallback } from 'react';

import useDelayFn from '~hooks/useDelayFn';
import { EditAssetsModal } from '~modules/media-library/view/Contribute/EditAssetsForm/EditAssetsModal';

interface EditAssetsModalControllerProps {
  onClose?: () => void;
  isOpen: boolean;
}

export function EditAssetsModalController({ isOpen, onClose }: EditAssetsModalControllerProps) {
  const delayedOnClose = useDelayFn(onClose, 500);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    onClose();

    delayedOnClose();
  }, [delayedOnClose, onClose]);

  return <EditAssetsModal isOpen={isOpen} onClose={handleOnClose} />;
}
